import styled from "styled-components";
import { theme } from "styles/theme";

export const PageContainer = styled.div`
  padding: 1rem 0;
`;

export const TabsContainer = styled.div`
  background-color: ${theme.colors.surface};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: none;
  margin-bottom: 1.5rem;
  overflow: hidden;

  .p-tabview {
    background: transparent;
  }

  .p-tabview-panels {
    background: ${theme.colors.surface};
    color: ${theme.colors.textPrimary};
    padding: 1.25rem;
  }

  .p-tabview-nav-content {
    overflow-x: auto;
    overflow-y: hidden;
  }

  .p-tabview-nav {
    border: none;
    border-bottom: 1px solid ${theme.colors.border};
    background-color: transparent;
    border-radius: 0;
    display: flex;
    flex-wrap: nowrap;
    align-items: stretch;
    gap: 0;
    margin: 0;
    padding: 0 0.5rem;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x proximity;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.colors.border};
      border-radius: 2px;
    }
  }

  .p-tabview-nav li {
    flex-shrink: 0;
    scroll-snap-align: start;
    overflow: hidden;
    margin: 0;
  }

  .p-tabview-nav-link {
    padding: 0.875rem 1.125rem !important;
    margin: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    color: ${theme.colors.textSecondary} !important;
    white-space: nowrap;
    min-height: 48px;
    min-width: 44px;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    line-height: 1.25;
    box-sizing: border-box;
    box-shadow: none !important;
  }

  .p-tabview-nav li.p-highlight .p-tabview-nav-link,
  .p-tabview-selected .p-tabview-nav-link {
    font-weight: ${theme.fontWeights.medium};
    color: ${theme.colors.textPrimary} !important;
    background: transparent !important;
    box-shadow: inset 0 -2px 0 ${theme.colors.tertiary} !important;
  }

  .p-tabview-nav li.p-highlight .p-tabview-nav-link i.pi,
  .p-tabview-selected .p-tabview-nav-link i.pi {
    color: ${theme.colors.tertiary} !important;
  }

  .p-tabview-ink-bar {
    display: none;
  }

  .p-tabview-nav-link > i,
  .p-tabview-nav-link > .pi,
  .p-tabview-nav-link .p-tabview-title {
    margin: 0;
  }

  .p-tabview-nav-link > i,
  .p-tabview-nav-link > .pi {
    flex-shrink: 0;
    color: inherit;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    .p-tabview-nav {
      padding: 0 0.25rem;
    }

    .p-tabview-nav-link {
      padding: 0.75rem 0.875rem !important;
    }

    .p-tabview-panels {
      padding: 1rem;
    }
  }
`;


export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;

export const ErrorContainer = styled.div`
  background-color: ${theme.colors.errorBg};
  color: ${theme.colors.statusInactiveText};
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
`;

export const StatusLayout = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 1.5rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const StatusTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  background-color: transparent;
  border: none;
  border-radius: 0;
  overflow: visible;
  box-shadow: none;
  margin-bottom: 1.5rem;

  th:nth-child(1),
  td:nth-child(1) {
    width: 22%;
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 18%;
  }

  th:nth-child(3),
  td:nth-child(3) {
    width: 28%;
  }

  th:nth-child(4),
  td:nth-child(4) {
    width: 32%;
  }
`;

export const TableHeader = styled.thead`
  background-color: transparent;
  color: ${theme.colors.textSecondary};
  border-bottom: 1px solid ${theme.colors.border};

  th {
    padding: 0.625rem 0;
    text-align: left;
    font-weight: ${theme.fontWeights.medium};
    font-size: 0.8rem;
    border-bottom: none;
  }
`;

export const TableBody = styled.tbody`
  color: ${theme.colors.textPrimary};

  tr:nth-child(even) {
    background-color: transparent;
  }

  tr:hover {
    background-color: ${theme.colors.bgLight};
  }
`;

export const TableRow = styled.tr<{ connected: boolean }>`
  border-bottom: 1px solid ${theme.colors.borderLight};
  opacity: ${(props) => (props.connected ? 1 : 0.75)};
`;

export const TableCell = styled.td`
  padding: 0.7rem 0;
  vertical-align: middle;
  color: ${theme.colors.textPrimary};
`;

export const StatusIndicator = styled.span<{ connected: boolean }>`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.connected ? theme.colors.tertiary : theme.colors.error};
  margin-right: 6px;
`;

export const StatusText = styled.span<{ connected: boolean }>`
  font-size: 0.8rem;
  color: ${(props) =>
    props.connected ? theme.colors.tertiary : theme.colors.error};
`;

export const ParamsCollapseHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
`;

export const ParamsCollapseTitle = styled.h3`
  margin: 0;
  font-size: 1rem;
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.textPrimary};
`;
